/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MonthlyUsageFiltersResponse } from '../../models/monthly-usage-filters-response';

export interface AdminGetMonthlyUsageFiltersGet$Params {

/**
 * Start date (inclusive)
 */
  from?: string;

/**
 * End date (inclusive)
 */
  to?: string;
}

export function adminGetMonthlyUsageFiltersGet(http: HttpClient, rootUrl: string, params?: AdminGetMonthlyUsageFiltersGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<MonthlyUsageFiltersResponse>> {
  const rb = new RequestBuilder(rootUrl, adminGetMonthlyUsageFiltersGet.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<MonthlyUsageFiltersResponse>;
    })
  );
}

adminGetMonthlyUsageFiltersGet.PATH = '/Admin/GetMonthlyUsageFilters';
